import { createContract } from '@exonet/jsonapi-fetcher/lib/resources';
import { searchContract } from '@exonet/jsonapi-fetcher/lib/search';

export const getDataManagerContract = (
  resource,
  controls,
  customerId,
  fields = [],
  resourceType = null,
) => {
  // Return search contract.
  if (controls?.search?.value) {
    return searchContract(resource)
      .describe(controls)
      .fields(fields)
      .resourceType(resourceType)
      .customer(customerId);
  }

  return createContract(resource).describe(controls);
};

export const getCustomers = () => createContract('customers');

export const getSupportToken = (supportTokenId) =>
  createContract('support_tokens').id(supportTokenId);

export const saveSupportToken = (dataObject) => createContract('support_tokens').save(dataObject);

export const getLocalSettings = () => createContract('local_settings');

export const updateLocalSetting = (dataObject) =>
  createContract('local_settings').id(dataObject.id()).save(dataObject);

export const getCountries = () => createContract('countries');

export const saveAction = (dataObject) =>
  dataObject.id() !== null
    ? createContract('actions').id(dataObject.id()).save(dataObject)
    : createContract('actions').save(dataObject);

export const getProduct = (id) => createContract('products').id(id);
